import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
  root: {
    height: "90vh",
    display: "flex",
    flexDirection: "column",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "24px",
  },
  dialogContent: {
    width: "400px",
    minWidth: "400px",
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      minWidth: "100%",
    },
  },
  input: {
    "& label.Mui-focused": {
      color: "#142C5C",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#142C5C",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#142C5C",
      },
      "&:hover fieldset": {
        borderColor: "#142C5C",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#142C5C",
      },
    },
  },
  closeButton: {
    position: "absolute",
    top: theme.spacing(1),
    right: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  tableHead: {
    position: "sticky",
    top: 0,
    backgroundColor: "#f5f5f5",
    zIndex: 1,
  },
  tableRow: {
    "&:nth-of-type(even)": {
      backgroundColor: "#f9f9f9",
    },
    "&:nth-of-type(odd)": {
      backgroundColor: "#fff",
    },
  },
  tableContainer: {
    maxHeight: "calc(100vh - 205px)",
    minHeight: "calc(100vh - 205px)",
    overflowX: "auto",
    overflowY: "auto",
    boxShadow: "none !important",
  },
  table: {
    border: "1px solid rgba(224, 224, 224, 1)",
    minWidth: "100%",
  },
  uploadButton: {
    height: "50px",
    minWidth: "10px",
    margin: "14px",
    marginTop: "20px",
    padding: "20px",
    display: "flex",
    alignItems: "center",
    backgroundColor: "#142C5C",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#0f2247",
    },
  },

  iconGrid: {
    marginTop: theme.spacing(2),
  },
  iconGridItem: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    textAlign: "center",
    border: "2px solid transparent",
    borderRadius: "4px",
    padding: theme.spacing(1),
    "&.selected": {
      borderColor: "#142C5C",
    },
  },
  iconLabel: {
    marginTop: theme.spacing(1),
  },
  selectedIconContainer: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(2),
    marginLeft: theme.spacing(2),
  },
  selectedIcon: {
    marginRight: theme.spacing(1),
  },
  paginationContainer: {
    display: "flex",
    justifyContent: "center",
    marginTop: theme.spacing(2),
  },
  hashtagContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
  hashtag: {
    display: "flex",
    alignItems: "center",
    backgroundColor: "#F0F0F0",
    padding: theme.spacing(0.5, 1),
    borderRadius: "4px",
  },
  cancelIcon: {
    marginLeft: theme.spacing(1),
    cursor: "pointer",
    color: "#777",
  },
  stickyHeader: {
    position: "sticky",
    top: "-1px",
    backgroundColor: theme.palette.background.paper,
    zIndex: 1,
  },
}));
